import {Component, OnInit} from '@angular/core';
import {Translation} from '../../models/translation';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.css']
})
export class MaintenanceComponent implements OnInit {

  public showMaintenance: boolean;
  public date: string;
  public time: string;
  public translation: Translation;

  constructor() { }

  ngOnInit(): void {
    if (sessionStorage.getItem('Maintenance') === 'true' && sessionStorage.getItem('ForceHideMaintenance') === 'false') {
      this.translation = JSON.parse(localStorage.getItem('Translation'));
      this.date = sessionStorage.getItem('MaintenanceDate');
      this.time = sessionStorage.getItem('MaintenanceTime');
      this.showMaintenance = true;
    }
  }

  closeMaintenance() {
    sessionStorage.setItem('ForceHideMaintenance', 'true');
    this.showMaintenance = false;
  }
}
